<template>
    <div
        class="o-modal o-modal--active"
        v-if="modal"
        @click="closeOutside"
    >
        <div class="o-modal__content">
            <button
                v-if="!disableClose"
                class="o-modal__close"
                aria-label="close"
                @click="closeModal"
            ></button>
            <slot name="content" :payload="modalPayload"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        disableClose: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modal() {
            return this.$store.getters.modalStatus(this.name)
        },
        modalPayload() {
            return this.$store.getters.modalPayload
        }
    },
    watch: {
        modal() {
            if(this.modal) {
                document.documentElement.style.overflow = 'hidden'
            } else {
                document.documentElement.style.overflow = 'auto'
            }
        }
    },
    methods: {
        closeOutside($event) {
            if($event.target.classList.contains('o-modal') && !this.disableClose) {
                this.closeModal()
            }
        },
        closeModal() {
            this.$store.dispatch('modalHide', this.name)
        }
    },
    mounted() {
        /**
         * Remove overflow when user reloads/goes back to a page with Modal opened.
         *
         * Example behaviour Delivery view -> click on new day -> go to Cart ->
         * click Go Back in the browser -> Modal is false, but no scroll present.
         *
         * */
        document.documentElement.style.overflow = 'auto'
    }
}
</script>